import ImageLoader from './ImageLoader';

export default class BlobImageLoader {
  private innerLoader: ImageLoader;

  public get isLoading() {
    return this.innerLoader.isLoading;
  }

  public get imageElement() {
    return this.innerLoader.imageElement;
  }

  public disconnect() {
    if (this.isLoading) {
      this.innerLoader.disconnect();
      URL.revokeObjectURL(this.imageElement.src);
    }
  }

  public constructor(src: Blob, onLoad: (img: HTMLImageElement) => void, onError: () => void) {
    const url = URL.createObjectURL(src);
    this.innerLoader = new ImageLoader(
      url,
      (img) => {
        URL.revokeObjectURL(url);
        onLoad(img);
      },
      () => {
        URL.revokeObjectURL(url);
        onError();
      },
    );
  }
}
